<template>
  <div>
    <div class="table-header row">
      <div>
        <input
          type="checkbox"
          v-model="isSelectAll"
          @change="selectAllChange"
        />
      </div>
      <div>
        创建时间/修改时间
      </div>
      <div>
        任务名称/任务类型
      </div>
      <div>
        执行文件/大小/链接
      </div>
      <div>创建人</div>
      <div>存储位置</div>
      <div>下发进度</div>
      <div>使用流量</div>
      <div>操作</div>
    </div>
    <div class="table-body">
      <div
        class="row"
        v-for="(item, index) in taskTableList"
        :key="index"
        @click="showTask(item)"
      >
        <!-- 选中 -->
        <div>
          <input
            type="checkbox"
            @click.stop
            v-model="item.select"
            @change="selectChange(item.select)"
          />
        </div>
        <!-- 创建时间/修改时间 -->
        <div class="twoLine">
          <p v-text="item.createTime ? item.createTime.replace('T', ' ') : '/'"></p>
          <p v-text="item.modifyTime ? item.modifyTime.replace('T', ' ') : '/'"></p>
        </div>
        <!-- 任务名称/任务类型 -->
        <div class="twoLine">
          <p v-text="item.taskName"></p>
          <p v-text="item.taskType == 0 ? '服务器任务' : '客户机任务'"></p>
        </div>
        <!-- 执行文件/大小/链接 -->
        <div class="twoLine">
          <p v-text="item.fileName"></p>
          <p
            v-text="item.fileSizeByte"
            v-show="item.fileSize"
          ></p>
          <p
            v-text="item.url"
            v-show="item.url && !item.fileSize"
          ></p>
        </div>
        <!-- 创建人 -->
        <div class="twoLine">
          <p v-text="item.createBy"></p>
          <p v-if="item.accountType == 0">主账号</p>
          <p v-if="item.accountType == 2">员工账号</p>
          <p v-if="item.accountType == 3">业主账号</p>
        </div>
        <!-- 存储位置 -->
        <div>
          <span
            v-show="item.taskType == 0"
            v-text="item.localFilePath ? item.localFilePath : 'wzServerTaskPkg'"
          ></span>
          <span
            v-show="item.taskType == 1"
            v-text="item.localFilePath ? item.localFilePath : 'wzClientTaskPkg'"
          ></span>
        </div>
        <!-- 下发进度 -->
        <div class="twoLine">
          <p v-show="item.releaseProgress">
            <span v-text="item.releaseProgress"></span>
            <span>%</span>
          </p>
          <p
            v-text="item.releaseDetails"
            v-show="item.releaseDetails"
            :style="{
              'padding-top': item.releaseProgress ? '0' : '10px',
            }"
          ></p>
          <span v-show="!item.releaseProgress && !item.releaseDetails">/</span>
        </div>
        <!-- 使用流量 -->
        <div>
          <span v-text="item.useFlowByte"></span>
        </div>
        <!-- 操作 -->
        <div class="operate">
          <a
            href="#"
            @click.prevent.stop="relatedBar(item)"
          >关联网吧</a>
          <span v-if="item.taskType == 0 && item.runType == 3">
            <a
              href="#"
              v-show="!item.disabled"
              @click.prevent.stop="rulesStatus(item, 2)"
            >停用</a>
            <a
              href="#"
              v-show="item.disabled"
              @click.stop.prevent="rulesStatus(item, 1)"
              style="color:#009900;"
            >启用</a>
          </span>
          <span v-if="item.taskType == 1 && item.runType == 4">
            <a
              href="#"
              v-show="!item.disabled"
              @click.prevent.stop="rulesStatus(item, 2)"
            >停用</a>
            <a
              href="#"
              v-show="item.disabled"
              @click.stop.prevent="rulesStatus(item, 1)"
              style="color:#009900;"
            >启用</a>
          </span>
          <a
            href="#"
            @click.stop.prevent="delTask(item)"
          >删除</a>
        </div>
      </div>
      <no-data
        style="height:auto;padding-top:20px;padding-bottom:20px;"
        v-show="tableList.length == 0 || loading"
        :nodata="tableList.length == 0 && !loading"
        :loading="loading"
      ></no-data>
    </div>
    <div
      class="table-pagination"
      v-show="tableList.length > 0"
    >
      <div style="float:left;padding-left:6px;">
        <input
          type="checkbox"
          v-model="isSelectAll"
          @change="selectAllChange"
        />
        <div
          class="default-btn com"
          @click.stop.prevent="delAllTask"
        >
          <span>删除</span>
        </div>
        <div
          @click.stop.prevent="rulesStatusAll(1)"
          class="default-btn com"
        >
          启用
        </div>
        <div
          class="default-btn com"
          @click.stop.prevent="rulesStatusAll(2)"
        >
          <span>停用</span>
        </div>
      </div>
      <page-component
        :total="total"
        :display="30"
        :current-page="page"
        @pagechange="pagechange"
      ></page-component>
    </div>
    <related-bar></related-bar>
    <del-task></del-task>
    <rules-status></rules-status>
  </div>
</template>

<script>
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
import NoData from "_c/noData/noData";
import relatedBar from "./modal/relatedBar/index";
import rulesStatus from "./modal/rulesStatus";
import delTask from "./modal/delTask";
import { bytesToSize } from "@/utils/byte.js";
export default {
  name: "tableData",
  components: {
    PageComponent,
    NoData,
    relatedBar,
    rulesStatus,
    delTask,
  },
  props: {
    tableList: {
      type: Array,
      default() {
        return [];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSelectAll: false,
      taskTableList: [],
    };
  },
  watch: {
    tableList() {
      console.log(this.tableList)
      this.isSelectAll = false;
      this.taskTableList = this.tableList.map((item) => {
        item.fileSizeByte = item.fileSize
          ? bytesToSize(item.fileSize)
          : 0 + "B";
        item.useFlowByte = bytesToSize(item.useFlow);
        item.select = false;
        return item;
      });
    },
  },
  methods: {
    selectedTaskIds() {
      let arr = [];
      this.taskTableList.forEach((item) => {
        if (item.select) {
          arr.push(item.taskId);
        }
      });
      return arr;
    },
    pagechange(page) {
      this.$emit("pagechange", page);
    },
    selectAllChange() {
      if (this.isSelectAll) {
        this.taskTableList.forEach((item) => {
          item.select = true;
        });
      } else {
        this.taskTableList.forEach((item) => {
          item.select = false;
        });
      }
    },
    selectChange(selectState) {
      if (selectState) {
        // 对单项进行选中
        // 判断是否全部选中
        let selectAllState = this.taskTableList.every((item) => {
          return item.select == true;
        });
        // 若全部选中,则为全选状态
        if (selectAllState) {
          this.isSelectAll = true;
        }
      } else {
        // 对单项进行取消
        this.isSelectAll = false;
      }
    },
    async rulesStatus(item, val) {
      if (val == 2) {
        let res = await window.$modal.tasksStatus.show(
          item.taskId,
          item.taskName,
          val
        );
        if (res) {
          this.$emit("refresh");
        }
      } else {
        this.$emit("openRule", item.taskId, val);
      }
    },
    async relatedBar(item) {
      let res = await window.$modal.relatedBar.show(item.taskId, item.taskType);
      if (res) {
        this.$emit("refresh");
      }
    },
    async delTask(item) {
      let res = await window.$modal.delTasksModal.show(
        item.taskId,
        item.taskName
      );
      if (res) {
        this.$emit("refresh", this.$del.delPage(this.total, 1, 30, this.page));
      }
    },
    rulesStatusAll(val) {
      this.$emit("rulesStatusAlls", val);
    },
    delAllTask() {
      this.$emit("delAllTask");
    },
    showTask(item) {
      this.$emit("showTask", item)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";
.row {
  width: 100%;
  cursor: pointer;
  @include clearfix();
  &:after {
    content: "";
    top: 0;
    left: 0;
    display: block;
    font-size: 0;
    height: 0;
    width: 0;
    clear: both;
    visibility: hidden;
  }
  > div {
    float: left;
    text-align: left;
    text-overflow: ellipsis;
    height: 50px;
    span {
      @include ellipsis();
      max-width: 100%;
    }
    p {
      @include ellipsis();
      max-width: 100%;
    }
    a {
      display: inline;
      text-align: left;
      text-indent: 0px;
      margin-right: 15px;
      color: rgb(0, 102, 204);
    }
    .disable {
      color: #7f7f7f;
    }
    input {
      cursor: pointer;
    }
  }

  > div:nth-child(1) {
    width: 25px;
    text-indent: 6px;
    input {
      position: relative;
      top: 2px;
    }
  }
  > div:nth-child(2) {
    width: 12%;
    @include ellipsis();
    text-align: left;
  }
  > div:nth-child(3) {
    width: 13%;
    @include ellipsis();
  }
  > div:nth-child(4) {
    width: 15%;
    @include ellipsis();
  }
  > div:nth-child(5) {
    width: 8%;
    @include ellipsis();
  }
  > div:nth-child(6) {
    width: 14%;
    @include ellipsis();
  }
  > div:nth-child(7) {
    width: 8%;
    @include ellipsis();
  }
  > div:nth-child(8) {
    width: 5%;
    @include ellipsis();
  }
  > div:nth-child(9) {
    width: 20%;
    @include ellipsis();
  }
}

.table-header {
  > div {
    height: 30px;
    line-height: 30px;
  }
}

.twoLine {
  p {
    line-height: normal;
    line-height: 16px;
  }
  p:nth-child(1) {
    padding-top: 10px;
  }
  p:nth-child(2) {
    color: #a1a1a1;
  }
}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;
  > div {
    display: inline-block;
    .com {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
input[type="checkbox"] {
  cursor: pointer;
}
</style>
